import { Modal, useModals } from 'almanac-ui/Modal'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { Heading } from 'blaze-ui/Heading/Heading'
import { MobileHeader } from 'screens/BrandKits/components/SourceMaterialModal/MobileHeader'
import React from 'react'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import Styles from 'screens/BrandKits/components/SourceMaterialModal/SourceMaterialModal.module.scss'
import ReactMarkdown from 'react-markdown'
import { ArrowLeft } from 'blaze-ui/icons'

interface Props {
  content: string
}

export const TranscriptionModal = ({ content }: Props) => {
  const { closeModal } = useModals()

  return (
    <Modal.Root size="lg" blaze onClose={closeModal} onPressOutside={closeModal} aria-label="Transcription">
      <ResponsiveDesign.Desktop>
        <Modal.Header
          title={
            <div className={Styles.header}>
              <IconButton variant="tertiary" size="xs" onPress={closeModal} icon={ArrowLeft} />
              <Heading level={3}>Transcription</Heading>
            </div>
          }
        />
      </ResponsiveDesign.Desktop>
      <ResponsiveDesign.Mobile>
        <MobileHeader onBack={closeModal}>Transcription</MobileHeader>
      </ResponsiveDesign.Mobile>
      <Modal.Content>
        <ReactMarkdown className={Styles.transcription}>{content}</ReactMarkdown>
      </Modal.Content>
    </Modal.Root>
  )
}
